<template>
    <div class="d-contents">
        <div
            v-for="key in Array.from(Array(count).keys())"
            :key="key"
            class="column"
            :class="classes"
        >
            <div
                class="card mb-2"
            >
                <div class="card-content">
                    <b-skeleton
                        width="50%"
                        size="is-medium"
                    />
                    <b-skeleton width="20%" />
                    <b-skeleton
                        size="is-medium"
                        :count="1"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            default: 1,
        },
        classes: {
            type: String,
            default: 'is-12',
        },
    },
};
</script>
